<template>
  <div class="container-fluid">
    <breadcrumb textItem="Novo Registro da Qualidade" />
    <div class="card border-left-theme shadow mb-5">
      <div class="card-body">
        <form @submit.prevent="saveRegistry">
          <div class="form-row">
            <div class="col-lg-3 col-md-6 mb-3">
              <label>
                Nº do Registro (consultar o SGQ):
                <span class="text-danger">*</span>
              </label>
              <input
                type="number"
                class="form-control"
                :class="{ 'is-invalid': $v.registry.numero.$error }"
                min="1"
                step="1"
                v-model="$v.registry.numero.$model"
              />
              <span
                v-if="!$v.registry.numero.required"
                class="invalid-feedback"
              >
                O campo é obrigatório
              </span>
            </div>
            <div class="col-lg-3 col-md-6 mb-3">
              <label>
                Data de Abertura: <span class="text-danger">*</span>
              </label>
              <input
                type="date"
                class="form-control"
                :class="{ 'is-invalid': $v.registry.dataAbertura.$error }"
                v-model="$v.registry.dataAbertura.$model"
              />
              <span
                v-if="!$v.registry.dataAbertura.required"
                class="invalid-feedback"
              >
                O campo é obrigatório
              </span>
            </div>
            <div class="col-lg-6 col-md-12 mb-3">
              <label>Seção: <span class="text-danger">*</span></label>
              <select
                class="form-control"
                :class="{ 'is-invalid': $v.registry.secao.$error }"
                v-model="$v.registry.secao.$model"
              >
                <option value="">Selecione uma opção</option>
                <option
                  v-for="section in sections"
                  :key="section.codigo"
                  :value="section.codigo"
                  :title="section.nome"
                >
                  {{ section.nome }}
                </option>
              </select>
              <span v-if="!$v.registry.secao.required" class="invalid-feedback">
                O campo é obrigatório
              </span>
            </div>
          </div>
          <hr />
          <div class="form-row">
            <div class="col-lg-6 col-md-12 mb-3">
              <label>
                Setor Responsável: <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                :class="{ 'is-invalid': $v.registry.responsavel.$error }"
                v-model="$v.registry.responsavel.$model"
              />
              <span
                v-if="!$v.registry.responsavel.required"
                class="invalid-feedback"
              >
                O campo é obrigatório
              </span>
            </div>
            <div class="col-lg-6 col-md-12 mb-3">
              <label>Tipo: <span class="text-danger">*</span></label>
              <select
                class="form-control"
                :class="{ 'is-invalid': $v.registry.tipo.$error }"
                v-model="$v.registry.tipo.$model"
              >
                <option value="">Selecione uma opção</option>
                <option
                  v-for="type in types"
                  :key="type"
                  :value="type"
                  :title="type"
                >
                  {{ type }}
                </option>
              </select>
              <span v-if="!$v.registry.tipo.required" class="invalid-feedback">
                O campo é obrigatório
              </span>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-12 mb-3">
              <label>Fato: <span class="text-danger">*</span></label>
              <textarea
                class="form-control"
                :class="{ 'is-invalid': $v.registry.descricao.$error }"
                rows="15"
                v-model="$v.registry.descricao.$model"
              />
              <span
                v-if="!$v.registry.descricao.required"
                class="invalid-feedback"
              >
                O campo é obrigatório
              </span>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-12 mb-3">
              <label>Risco:</label>
              <textarea
                class="form-control"
                rows="8"
                v-model="registry.risco"
              />
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-12 mb-3">
              <label>Evidência: <span class="text-danger">*</span></label>
              <textarea
                class="form-control"
                :class="{ 'is-invalid': $v.registry.evidencia.$error }"
                rows="15"
                v-model="$v.registry.evidencia.$model"
              />
              <span
                v-if="!$v.registry.evidencia.required"
                class="invalid-feedback"
              >
                O campo é obrigatório
              </span>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-12 mb-3">
              <label>Requisito: <span class="text-danger">*</span></label>
              <textarea
                class="form-control"
                :class="{ 'is-invalid': $v.registry.requisito.$error }"
                rows="8"
                v-model="$v.registry.requisito.$model"
              />
              <span
                v-if="!$v.registry.requisito.required"
                class="invalid-feedback"
              >
                O campo é obrigatório
              </span>
            </div>
          </div>
          <hr />
          <div class="form-row">
            <div class="col-md-12 mb-3">
              <label>
                Ação de Correção (ação imediata para corrigir o problema):
                <span class="text-danger">*</span>
              </label>
              <textarea
                class="form-control"
                :class="{ 'is-invalid': $v.registry.acaoCorrecao.$error }"
                rows="15"
                v-model="$v.registry.acaoCorrecao.$model"
              />
              <span
                v-if="!$v.registry.acaoCorrecao.required"
                class="invalid-feedback"
              >
                O campo é obrigatório
              </span>
            </div>
          </div>
          <hr />
          <div class="form-row">
            <div class="col-md-12 mb-3">
              <label>Identificação da causa da não conformidade:</label>
              <textarea
                class="form-control"
                rows="15"
                v-model="registry.causaNaoConformidade"
              />
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-12 mb-3">
              <label>Anexos:</label>
              <input
                type="file"
                class="form-control-file"
                multiple
                @change="handleFileUploads($event)"
              />
            </div>
          </div>
          <div class="text-right mt-2">
            <router-link
              to="/home"
              class="btn btn-outline-secondary"
              title="Cancelar"
            >
              Cancelar
            </router-link>
            <button
              type="submit"
              class="btn btn-theme ml-2"
              title="Cadastrar"
              :disabled="$v.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="fas fa-spinner fa-spin"></i>
              </span>
              <span v-else>Cadastrar</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { dateNow } from '@/utils/date'
import Breadcrumb from '@/components/commons/Breadcrumb.vue'

export default {
  name: 'New',

  components: {
    Breadcrumb,
  },

  data() {
    return {
      registry: {
        numero: '',
        dataAbertura: dateNow(),
        secao: '',
        responsavel: '',
        tipo: '',
        descricao: '',
        risco: '',
        evidencia: '',
        requisito: '',
        acaoCorrecao: '',
        causaNaoConformidade: '',
      },
      sections: null,
      types: [
        'Não Conformidade',
        'Reclamação de Cliente',
        'Oportunidade de Melhoria',
        'Observação',
        'Prevenção/Risco',
        'Planejamento de Mudanças',
      ],
      files: null,
      disableButton: false,
    }
  },

  methods: {
    async getSections() {
      try {
        this.sections = await this.$store.dispatch('getSections')
      } catch (error) {
        if (error && error.message) {
          this.$snotify.warning(error.message, 'Atenção!')
        } else {
          this.$snotify.error(
            'Não foi possível se conectar ao servidor.',
            'Erro!',
          )
        }
      }
    },

    handleFileUploads(event) {
      this.files = event.target.files
    },

    async saveRegistry() {
      if (!this.$v.$invalid) {
        this.disableButton = true
        try {
          const response = await this.$store.dispatch(
            'saveRegistry',
            this.registry,
          )

          if (this.files) {
            this.submitFiles(response.registroId)
          } else {
            this.disableButton = false
            this.$snotify.success(response.message)

            this.$router.push({
              name: 'Details',
              params: { registryId: response.registroId },
            })
          }
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$snotify.warning(error.message, 'Atenção!')
          } else {
            this.$snotify.error(
              'Não foi possível se conectar ao servidor.',
              'Erro!',
            )
          }
        }
      }
    },

    async submitFiles(registryId) {
      try {
        const formData = new FormData()

        for (let i = 0; i < this.files.length; i += 1) {
          const file = this.files[i]
          formData.append(`anexos[${i}]`, file)
        }

        const response = await this.$store.dispatch('saveAttachment', {
          registryId,
          attachment: formData,
        })

        this.disableButton = false
        this.$snotify.success(response.message)

        this.$router.push({
          name: 'Details',
          params: { registryId },
        })
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$snotify.warning(error.message, 'Atenção!')
        } else {
          this.$snotify.error(
            'Não foi possível se conectar ao servidor.',
            'Erro!',
          )
        }
      }
    },
  },

  validations: {
    registry: {
      numero: {
        required,
      },
      dataAbertura: {
        required,
      },
      secao: {
        required,
      },
      responsavel: {
        required,
      },
      tipo: {
        required,
      },
      descricao: {
        required,
      },
      evidencia: {
        required,
      },
      requisito: {
        required,
      },
      acaoCorrecao: {
        required,
      },
    },
  },

  mounted() {
    this.getSections()
  },
}
</script>
